<template>
  <div class="vehicle-front">
    <lead :headOption="headOption" />
    <main class="main">
      <router-view />
    </main>
    <foote />
  </div>
</template>
<script>
import lead from "@/components/common/head";
import foote from "@/components/common/footer";

export default {
  components: {
    lead,
    foote
  },
  data() {
    return {
      // 顶部模块标题：
      headOption: {
        link: "/vehicle",
        title: "车辆管理"
      },
    }
  }
};
</script>     

<style lang="scss">
</style>